import type { Category } from './categories'

type enabledPagesItem = { journeyType: Category }

export const enabledPages: { [path: string]: enabledPagesItem } = {
  '/reviews/laptops': { journeyType: 'laptops' },
  '/l/computing/laptops': { journeyType: 'laptops' },
  '/reviews/laptops/article/how-to-buy-the-best-laptop-aNXXi9d9wmfn': { journeyType: 'laptops' },
  '/reviews/laptops/article/top-laptops-by-type/best-windows-laptops-ajKon3C9jxLz': {
    journeyType: 'laptops',
  },
  '/reviews/laptops/article/best-cheap-laptops-aLsgM2F0QHcg': { journeyType: 'laptops' },
  '/reviews/laptops/article/laptops-for-students-aafOE6Y2pcyL': { journeyType: 'laptops' },
  '/reviews/laptops/article/top-laptops-by-type/best-chromebooks-a02kZ9W0KQF4': {
    journeyType: 'laptops',
  },
  '/reviews/laptops/article/top-laptops-by-type/best-macbooks-abjug7l18D2R': {
    journeyType: 'laptops',
  },
  '/reviews/laptops/article/most-reliable-laptop-brands-akQtM7w0zvuR': { journeyType: 'laptops' },
  '/reviews/laptops/article/which-dont-buy-laptops-aOujr8Q4IiPx': { journeyType: 'laptops' },
  '/reviews/laptops/article/best-laptop-deals-a0gLg0i9nmhc': { journeyType: 'laptops' },
  '/reviews/laptops/article/top-laptops-by-type/mac-vs-pc-vs-chromebook-how-to-choose-the-right-laptop-aacuu8i4xyVQ':
    { journeyType: 'laptops' },
  '/reviews/laptops/article/how-we-test-laptops-arGXp0K3GO9v': { journeyType: 'laptops' },
  '/reviews/laptops/article/how-to-speed-up-a-slow-computer-aKcRy8S1oufr': {
    journeyType: 'laptops',
  },
  '/reviews/mattresses': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/how-to-buy-the-best-mattress-atlAf8V9fiZN': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/best-air-beds-aelZB9F9mFCk': { journeyType: 'mattresses' },

  '/reviews/mattresses/article/uk-mattress-sizes-bed-mattress-size-guide-aDx4r9b4T99o': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/best-mattress-deals-ar6DL1l7Cb9Z': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/best-mattresses-for-back-pain-ahA7w6g99PXC': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/popular-ikea-mattresses-aWsuc0F4pfZ3': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/how-to-clean-a-mattress-abnpZ8R3Sz2J': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/how-to-return-a-mattress-ak2pA0L2M9PF': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/best-hybrid-mattresses-aDQyk7j4aDlC': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/dont-buy-mattresses-aXaih4e7Oq1L': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/how-to-dispose-of-a-mattress-avTxg0t48NMG': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/best-mattresses-for-side-sleepers-a7RlH8L5T1PX': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/which-mattress-brands-asOxA9x6qgsU': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/top-pocket-sprung-mattresses-arCsR6Z9qbYB': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/emma-vs-simba-vs-eve-comparison-aT9rZ9q5BoGI': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/top-memory-foam-mattresses-a6D2J3D67Pex': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/best-heated-throws-aMEGw3P8aGCe': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/popular-silentnight-mattresses-awhCl4a8PBLS': {
    journeyType: 'mattresses',
  },
  '/reviews/mattresses/article/how-we-test-mattresses-aKTG81m1hH9f': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/best-electric-blankets-avrLG0b2886v': { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-a-silentnight-mattress-aGrek4M3d84r':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-a-john-lewis-mattress-a6rY03D03I3U':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-an-ikea-mattress-awHLZ9J5fodD':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-an-emma-mattress-atfsx0Z4fKQo':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-a-dreams-mattress-apWJq6V2M03G':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-a-bensons-for-beds-mattress-aQenv0b9OeAc':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/returning-a-mattresses-from-some-of-the-biggest-retailers/returning-an-eve-mattress-aMY6w5a8395k':
    { journeyType: 'mattresses' },
  '/reviews/mattresses/article/how-to-buy-the-best-bed-axyMn3M1noJq': { journeyType: 'mattresses' },
}
